<template>
    <div class="innerBox">
  
      <h1 class="mb-3">Laporan Step Bengkel</h1>
  
      <!-- <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox" style="padding:0 25%">
          <div class="col row">
            <div class="col-md-6" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Work Order Code</label>
              <input type="text" class="form-control" placeholder="Ketik work order code" style="height: 43px;" v-model="filter.work_order_code">
            </div>
            <div class="col-md-6" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
            </div>
          </div>
        </div>
      </panel> -->
  
      <!-- <vue-universal-table
        api_url="/api/v1/workorder/listing/outstanding-estimations/sparepart"
        :fields="vue_universal_table.fields"
        :special_buttons="vue_universal_table.special_buttons"
        :disable_sort="true"
        :update="vue_universal_table.update"
        :filter="filter"
        :process_data="vue_universal_table.process_data"
        :export_config="vue_universal_table.export_config"
      ></vue-universal-table> -->
	  <vue-universal-table
        api_url="/api/v1/workorder/listing/get-idle-workorder"
        :special_buttons="vue_universal_table.special_buttons"
        :disable_sort="true"
        :update="vue_universal_table.update"
        :filter="filter"
		:fields="vue_universal_table.fields"
        :process_data="vue_universal_table.process_data"
        :export_config="vue_universal_table.export_config"
      ></vue-universal-table>
  
    </div>
  </template>
  
  <script>  
    export default {
      data () {
        return {
          mobile : this.isMobile(),
          modal : {
            view : false,
          },
          rangeConfig: {
            mode: 'range',
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          detailId : '',
          selected : {
            date : '',
          },
          filter : {
            work_order_code : '',
          },
          vue_universal_table : {
            fields : [
                {
                    title : 'Work Order ID',
                    variable : 'form_code'
                },
				{
                    title : 'No Polisi Mobil',
					variable : 'registration'
                },
                {
                    title : 'Brand Mobil',
                    variable : 'car_name'
                },
				{
                    title : 'Status',
                    variable : 'working'
                },
				{
					title : 'Ongoing Step Bengkel',
					variable : 'ongoing_step_name'
				},
                {
                    title : 'Tanggal Mulai Pekerjaan',
                    variable : 'work_start_time'
                },
            ],
            special_buttons : ['exportToExcel'],
            update : 0,
            export_config : {
              name : 'Laporan Step Bengkel',
              type : 'xlsx',
              all : true
            },
            process_data : `
				for(var i in data) {
					data[i].working = data[i].working ? 'Sedang Pengerjaan' : 'Pending'
					data[i].work_start_time = data[i].work_start_time ? this.moment(data[i].work_start_time).format('MMM DD, Y HH:mm') : '-'
				}
            `,
          },
          dummyData : null,
        }
      },
      mounted () {
        this.generateData()
      },
      methods : {
        viewDetail(a){
          console.log(JSON.parse(a).form_code);
          this.detailId = JSON.parse(a).form_code;
          this.modal.view = true;
        },
        generateData(){
            var names = ['Apple', 'Orange', 'Lemon', 'Kiwi', 'Pear']
            var dummy = []
            for(var i = 0; i < 15; i++){
                dummy.push({
                    woNumber : this.randomInt(1000000, 10000000),
                    total_sparepart : this.randomInt(1, 10),
                    total_price : this.randomInt(100000, 10000000),
                    insurance_name : names[this.randomInt(0,4)],
                    customer_name : names[this.randomInt(0,4)],
                })
            }
            this.dummyData = dummy
        },
      }
    }
  </script>
  
  <style scoped>
  
  </style>